export enum DownloadResumeTypes {
  FETCH_DOWNLOAD_RESUME_SUCCESS = "FETCH_DOWNLOAD_RESUME_SUCCESS",
  FETCH_DOWNLOAD_RESUME_FAILURE = "FETCH_DOWNLOAD_RESUME_FAILURE",
  FETCH_DOWNLOAD_RESUME_REQUEST = "FETCH_DOWNLOAD_RESUME_REQUEST"
}